export default "__VITE_PUBLIC_ASSET__1d5de176__"